export const environment = {
  production: false,
  apiBaseUrl: 'https://api-stage-universalswap.apps.stargate.is',
};
